/*
 * Per-rule copy for the Task Generation card. Pure and tested because
 * index.jsx has no test harness.
 */

import moment from 'moment-timezone';

// For the no-join rules the server computes dueAt = session start + delay, so
// the value is not a wait after a trigger.
const SESSION_START_DELAY_TYPES: ReadonlyArray<string | null | undefined> = [
  'PRE_SESSION_NO_JOIN',
  'REMINDER_LINK_NO_JOIN'
];

export const delay_label = (taskType: string | null | undefined): string => {
  if (SESSION_START_DELAY_TYPES.includes(taskType)) return 'Minutes after session start';
  if (taskType === 'REMINDER_REPLY') return 'Reply window (minutes)';
  return 'Delay (minutes)';
};

export const delay_title = (taskType: string | null | undefined): string => {
  if (SESSION_START_DELAY_TYPES.includes(taskType)) {
    return 'How many minutes after the session starts to check whether the member joined. Blank = the server default.';
  }
  if (taskType === 'REMINDER_REPLY') {
    return 'How long to wait for a reply to the reminder before creating the task. Blank = the server default.';
  }
  return 'How long to wait after the trigger before re-checking whether the member got through on their own. Blank = the server default.';
};

// Mirrors goserver: a blank instant expiry enforces 12 h on every rule.
export const BLANK_EXPIRY_MINUTES = 720;

export const EXPIRY_PLACEHOLDER = String(BLANK_EXPIRY_MINUTES);

export const EXPIRY_TITLE =
  'An instant task nobody touches within this many minutes is auto-completed. Leave blank for 12 h.';

// '' when the server sent no enabled_at or an unparseable one.
export const enabled_since_label = (enabledAt: unknown): string => {
  if (!enabledAt || typeof enabledAt !== 'string') return '';
  const m = moment(enabledAt, moment.ISO_8601, true);
  if (!m.isValid()) return '';
  return `Enabled since ${m.tz('Asia/Kolkata').format('D MMM YYYY')}`;
};
